/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export default {
  command_intelligence_drawer_title: 'Command Intelligence',
  command_intelligence_drawer_resize_handle: 'Перетащите, чтобы изменить размер панели',
  command_intelligence_close_aria: 'Закрыть помощника',
  command_intelligence_send_aria: 'Отправить сообщение',
  command_intelligence_stop_aria: 'Остановить ответ',
  command_intelligence_composer_input_aria: 'Сообщение для Command Intelligence',
  command_intelligence_drawer_more_options: 'Дополнительные параметры',
  command_intelligence_dock_position: 'Позиция закрепления',
  command_intelligence_dock_left: 'Слева',
  command_intelligence_dock_right: 'Справа',
  command_intelligence_dock_top: 'Сверху',
  command_intelligence_dock_bottom: 'Снизу',
  command_intelligence_panel_layout: 'Макет панели',
  command_intelligence_panel_layout_overlap: 'Накладывать на содержимое',
  command_intelligence_panel_layout_push: 'Сдвигать содержимое',
  command_intelligence_panel_auto_hide_overlap: 'Автоматически скрывать при клике снаружи',
  command_intelligence_session_reset: 'Сбросить разговор',
  command_intelligence_try_one_of_these: 'Попробуйте одно из этих',
  command_intelligence_attach_hint: 'Прикрепите элементы контекста, чтобы начать задавать вопросы.',
  command_intelligence_welcome_subhead: 'Задайте вопрос, чтобы начать.',
  command_intelligence_attach_modal_title: 'Прикрепить контекст',
  command_intelligence_attach_modal_subtitle:
    'Выберите из элементов в этом представлении. Уже прикреплённые элементы затемнены.',
  command_intelligence_attach_modal_search_placeholder: 'Поиск…',
  command_intelligence_attach_modal_pool:
    '{count, plural, one {# элемент доступен} few {# элемента доступно} many {# элементов доступно} other {# элемента доступно}} · выбрано {selected}',
  command_intelligence_attach_modal_empty: 'Нет доступных элементов для прикрепления',
  command_intelligence_attach_modal_no_results: 'Ни один элемент не соответствует поиску',
  command_intelligence_context_bar_attached_section: 'Прикреплено ({count})',
  command_intelligence_context_bar_clear_attached: 'Очистить',
  command_intelligence_context_bar_add: 'Прикрепить контекст',
  command_intelligence_placeholder_ready: 'Задайте вопрос…',
  command_intelligence_placeholder_attach: 'Прикрепите контекст, чтобы задать вопрос…',
  command_intelligence_composer_submit_hint: 'Enter — отправить · Shift+Enter — новая строка',
  command_intelligence_composer_stop_hint: 'Остановить · черновик следующего сообщения во время ожидания',
  command_intelligence_response_stopped: 'Ответ остановлен',
  command_intelligence_generation_in_progress: 'Обработка вашего вопроса',
  command_intelligence_generation_trace_title: 'Выполненные шаги',
  command_intelligence_generation_trace_toggle: 'Показать шаги',
  command_intelligence_generation_trace_summary: 'Выполнено {completed} из {total} шагов',
  command_intelligence_generation_trace_summary_generic: 'Шаги генерации',
  command_intelligence_generation_tool_count:
    '{count, plural, one {# инструмент} few {# инструмента} many {# инструментов} other {# инструмента}}',
  command_intelligence_generation_turn_label: 'Ход {turn} из {total}',
  command_intelligence_generation_turn_completed: 'Завершён ход {turn} из {total}',
  command_intelligence_generation_turn_completed_elapsed: 'Завершён ход {turn} из {total} (прошло {seconds} с)',
  command_intelligence_generation_turn_completed_with_tools: 'Завершён ход {turn} из {total} — использовано {tools}',
  command_intelligence_generation_tools_used: 'Использовано {tools}',
  command_intelligence_reasoning_thinking: 'Думаю…',
  command_intelligence_reasoning_thought_for_seconds: 'Думал {seconds} секунд',
  command_intelligence_reasoning_waiting: 'Обработка вашего вопроса…',
  command_intelligence_attach_modal_done: 'Готово',
  command_intelligence_attach_modal_attached_badge: 'прикреплено',
  command_intelligence_attach_modal_attach: 'Прикрепить',
  command_intelligence_attach_modal_attach_count: 'Прикрепить ({count})',
  command_intelligence_attach_modal_close_aria: 'Закрыть выбор',
  command_intelligence_session_limit_context: 'Достигнут лимит контекста. Сбросьте разговор, чтобы продолжить.',
  command_intelligence_session_limit_prompt: 'Достигнут лимит сообщений. Сбросьте разговор, чтобы продолжить.',
  command_intelligence_suggested_followups: 'Предлагаемые уточнения',
  command_intelligence_credit_warning_line: 'Использовано {pct}% месячных кредитов ИИ для {scope}',
  command_intelligence_tooltip_prompts: '{count} из {max} сообщений ({pct}%)',
  command_intelligence_tooltip_context: '{used} из {max} токенов контекста ({pct}%)',
  command_intelligence_tooltip_context_idle: 'Использование контекста отображается после первого ответа',
  command_intelligence_credits_loading: 'Загрузка кредитов…',
  command_intelligence_credits_unavailable: 'Кредиты недоступны',
  command_intelligence_credits_tooltip: 'Месячные кредиты ИИ за {monthKey}',
  command_intelligence_credits_tooltip_short: 'Месячные кредиты ИИ',
  command_intelligence_credits_scope_profile: 'Профиль',
  command_intelligence_credits_scope_entity: 'Сущность',
  command_intelligence_credits_used_of_cap: '{used} из {cap} кредитов',
  command_intelligence_credits_used_no_cap: 'Использовано {used} кредитов',
  command_intelligence_credits_monthly_title: 'Месячные кредиты ИИ',
  command_intelligence_compare_aria: 'Сравнить агентов',
  command_intelligence_compare_tooltip: 'Запустить один и тот же вопрос для нескольких профилей агентов',
  command_intelligence_compare_cancelled: 'Сравнение отменено',
  command_intelligence_compare_branch_failed: 'Ветка сравнения не удалась',
  command_intelligence_compare_title: 'Сравнение агентов',
  command_intelligence_compare_stats: '{durationMs} мс · {model} · {inTok} вх. / {outTok} исх. · {agentRef}',
  command_intelligence_compare_error: '{message}',
  command_intelligence_profile_agent: '{agentRef}',
  command_intelligence_feedback_good_response: 'Хороший ответ',
  command_intelligence_feedback_bad_response: 'Плохой ответ',
  command_intelligence_feedback_dialog_title: 'Оставить отзыв',
  command_intelligence_feedback_dialog_body:
    'Помогите нам улучшиться, оставив отзыв об этом ответе. Ваш отзыв будет отправлен нашей операционной команде.',
  command_intelligence_feedback_response_label: 'Ответ',
  command_intelligence_feedback_input_label: 'Ваш отзыв (необязательно)',
  command_intelligence_feedback_input_placeholder: 'Что было неправильным или бесполезным в этом ответе?',
  command_intelligence_feedback_submit: 'Отправить отзыв',
  command_intelligence_feedback_submit_error: 'Не удалось отправить отзыв. Повторите попытку.',
  command_intelligence_feedback_question_understanding: 'Понял ли агент, что вы хотели?',
  command_intelligence_feedback_question_readability: 'Был ли ответ лёгким для чтения и использования?',
  command_intelligence_feedback_section_understanding: 'Понимание',
  command_intelligence_feedback_section_readability: 'Читаемость',
  command_intelligence_feedback_choice_none: 'Нет',
  command_intelligence_feedback_choice_misunderstood_task: 'Неправильно понял задачу',
  command_intelligence_feedback_choice_ignored_constraint: 'Игнорировал ограничение',
  command_intelligence_feedback_choice_wrong_scope: 'Неверная область',
  command_intelligence_feedback_choice_visually_hard_to_read: 'Визуально трудно читать',
  command_intelligence_feedback_choice_wrote_too_much: 'Слишком много текста',
  command_intelligence_feedback_choice_explanation_not_trustworthy: 'Объяснение ненадёжно',
  command_intelligence_copy_aria: 'Копировать в буфер обмена',
  command_intelligence_error_missing_invoke_permission:
    'У вас нет разрешения на использование Command Intelligence для этого агента. Попросите администратора предоставить необходимые разрешения Intelligence (например, analyst).',
  command_intelligence_access_denied_title: 'Требуется доступ',
  command_intelligence_error_session_expired: 'Ваша сессия истекла. Обновите страницу и войдите снова.',
};
